<template>
  <div class="image-news w-full h-full">
    <column-header
      v-show="data.showTitle"
      class="mb-10px"
      :title="title"
      :showMore="data.showMore"
      @loadMore="loadMore"
    />
    <el-carousel :autoplay="false" arrow="always" indicator-position="none" :class="getBodyClass()">
      <el-carousel-item v-for="item in Math.ceil(list.length / 4)" :key="item">
        <div
          class="relative inline-block"
          v-for="(imgItem, index) in getGroupList(item - 1)"
          :key="imgItem.id"
          :style="{
            marginLeft: index % col === 0 ? '0px' : '20px',
            height: `calc(100% / ${row} - 8px * ${row - 1} / ${row})`,
            width: `calc(100% / ${col} - 20px * ${col - 1} / ${col})`,
          }"
          @click="toDetail(imgItem)"
        >
          <el-image
            :src="`${fileUrl}${imgItem.indexImage}`"
            :fit="data.imageFit || 'fill'"
            class="cursor-pointer h-full w-full"
          ></el-image>
          <div
            class="py-10px px-20px bg-hex-00000080 truncate text-hex-fff text-15px absolute bottom-0 w-full font-bold text-center"
            v-if="data.showTitle"
            :title="imgItem.title"
          >
            {{ imgItem.title }}
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { ColumnTableApi, ColumApi } from '@wiz-api/workbench-std'
import { informationPublishMap } from '@/modules/portal-management/js/config'
import addRequestQueue from '@/assets/js/RequestQueue'

const columnTableApi = new ColumnTableApi()
const columApi = new ColumApi()

const columnHeader = () => {
  return import('./ColumnHeader')
}
const columnImageType = informationPublishMap.column.columnImgText // 图片栏目

export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
    mode: {
      type: String,
      default: 'update', // update/view   update模式不触发点击
    },
  },
  components: {
    columnHeader,
  },
  computed: {
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/image/`
    },
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
  },
  data() {
    return {
      page: {
        pageNo: 1,
        pageSize: 15,
        totalCount: 0,
      },
      list: [],
      title: '滚动图窗',
      source: 1,
      row: 1,
      col: 4,
    }
  },
  methods: {
    loadMore() {
      if (this.mode !== 'update') {
        window.open(
          `${window.location.origin}${window.location.hash ? '/#' : ''}${
            this.routerBase
          }/integration/portal/homepage?columnId=${this.data.dataSource}`
        )
      }
    },
    getBodyClass() {
      if (this.data.showTitle) {
        return 'h-[calc(100%-66px)]'
      }
      return 'h-full'
    },
    getGroupList(index) {
      const num = this.row * this.col
      const startIndex = index * num
      return this.list.slice(startIndex, startIndex + num)
    },
    toDetail(item) {
      if (this.mode === 'view') {
        if (item.externalLink) {
          window.open(item.externalLink)
        } else {
          window.open(
            `${window.location.origin}${window.location.hash ? '/#' : ''}${
              this.routerBase
            }/integration/portal/ColumnDetail?id=${item.id}&type=${columnImageType}`
          )
        }
      }
    },
    async getListData() {
      const [err, res] = await addRequestQueue(() => {
        return columnTableApi.getImageColumnTable(this.page.pageNo, this.page.pageSize, {
          columnId: this.data.dataSource,
          isShow: true,
        })
      })
      if (!err) {
        this.list = res.items
        this.page.totalCount = res.totalCount
      }
    },
    async getTitle() {
      if (this.data.title && this.data.dataSource) {
        this.getListData()
        return
      }
      if (this.data.dataSource !== '' && this.data.dataSource != null) {
        const [err, res] = await columApi.getColumnDetail(this.data.dataSource)
        if (!err) {
          this.title = res.name
          this.source = res.source
          this.getListData()
        }
      }
    },
  },
  created() {
    this.getTitle()
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(val, oldVal) {
        if (!_.isEmpty(val)) {
          if (val.title) this.title = val.title
          this.page.pageSize = val.pageSize
          if (val.dataSource !== oldVal?.dataSource || val.pageSize !== this.page.pageSize) {
            this.getTitle()
          }
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.image-news {
  &::v-deep .el-carousel {
    .el-carousel__container {
      height: 100%;
    }
    .el-carousel__arrow {
      width: 30px;
      height: 40px;
      border-radius: unset;
      background-color: rgba(0, 0, 0, 0.3);
      &:hover {
        background-color: rgba(0, 0, 0, 0.4);
      }
    }
    .el-carousel__arrow--left {
      left: 0;
    }
    .el-carousel__arrow--right {
      right: 0;
    }
  }
}
</style>
